import React, { useState } from "react";
import { UsuariosABM } from "./Usuarios/UsuariosABM";
import { UsuariosListado } from "./Usuarios/UsuariosListado";
import { type Usuario } from "@/lib/api";
import { useRegisterOpcionesAbmNav } from "./opcionesAbmBreadcrumb";

type UsuariosView = "ABM" | "Listado";

export function UsuariosSection() {
  const [currentView, setCurrentView] = useState<UsuariosView>("Listado");
  const [selectedItem, setSelectedItem] = useState<Usuario | null>(null);

  const handleEdit = (item: Usuario) => {
    setSelectedItem(item);
    setCurrentView("ABM");
  };

  const handleBack = () => {
    setSelectedItem(null);
    setCurrentView("Listado");
  };

  const handleNew = () => {
    setSelectedItem(null);
    setCurrentView("ABM");
  };

  useRegisterOpcionesAbmNav(
    currentView === "ABM",
    selectedItem != null,
    handleBack
  );

  return (
    <div className="space-y-4">
      {currentView === "ABM" ? (
        <UsuariosABM
          selectedItem={selectedItem}
          onBack={handleBack}
          onUserCreated={handleBack}
        />
      ) : (
        <UsuariosListado onEdit={handleEdit} onNew={handleNew} />
      )}
    </div>
  );
}